import React from 'react';
import PropTypes from 'prop-types';

import './AnnouncementBanner.scss';

const AnnouncementBanner = ({ children, additionalClass, onClose }) => (
  <div className="announcement-banner">
    <div className={`w-container ${additionalClass}`}>{children}</div>

    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
    <a href="#" className="announcement-banner--close" onClick={onClose}>
      &#10005;
    </a>
  </div>
);

AnnouncementBanner.propTypes = {
  children: PropTypes.node,
  additionalClass: PropTypes.string,
  onClose: PropTypes.func,
};

AnnouncementBanner.defaultProps = {
  children: null,
  additionalClass: null,
  onClose: null,
};

export default AnnouncementBanner;

export const AnnouncementBannerSpace = () => (
  <div className="announcement-banner-space" />
);
